import React, { useContext, useEffect, useRef, useState } from 'react';
import FadeIn from 'react-fade-in';
import { Observer } from 'mobx-react-lite';
import momentLocalizer from 'react-widgets-moment';
import MaskedInput from 'react-text-mask'
import { GlobalHotKeys } from 'react-hotkeys';
import { DateBox } from 'devextreme-react';
import { toast } from 'react-toastify';
import moment from 'moment';

import BodyEnd from '../../_shared/BodyEnd';
import ConfirmModal from '../../_shared/ConfirmModalComponent';
import { quickDrawerFocus, renderQuickDrawerLoading } from '../../_shared/QuickDrawer';
import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';
import PresetColorBox from '../../_shared/PresetColorBox';

import ServiceAttributeUpdateStore from '../../../../stores/ServiceAttributeUpdateStore';
import ServiceOverrideUpdateStore from '../../../../stores/ServiceOverrideUpdateStore';
import QuickDrawerStore from '../../../../stores/QuickDrawerStore';

import * as ErrorMessages from '../../../../constants/errorMessages';
import * as MaskKeys from '../../../../constants/maskKeys';
import * as fn from '../../../../utilities/_functions';
import * as oh from '../../../../utilities/operationHelper';
import api from '../../../../api';

import './UpdateServiceAttribute.scss';

moment.locale('en');
momentLocalizer();


function UpdateServiceAttribute(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const serviceUpdateTimer = useRef(null);
    const confirmModalRef = useRef(null);
    const serviceAttribute = useContext(ServiceAttributeUpdateStore);
    const serviceUserOverride = useContext(ServiceOverrideUpdateStore);
    const quickDrawer = useContext(QuickDrawerStore);
    const [ready, setReady] = useState(false);
    const [examTemplates, setExamTemplates] = useState([]);

    const loadData = async () => {
        try {
            const { data } = await api.ExamTemplates.search({
                parameters: [
                    {
                        field: 'PublishedTemplateId',
                        operator: '!=',
                        value: null
                    }
                ],
                sortByFields: [{ field: 'Name', direction: 'ASC' }],
                includeTotalCount: false,
            });
            if (isMounted.current) {
                const examTemplates = data && data.result && data.result.length > 0 ? data.result : [];
                setExamTemplates(examTemplates);
                setReady(true);
            }
        }
        catch (e) {
            window.alert(e);
        }
    }

    useEffect(() => {
        loadData();
        quickDrawerFocus(props.drawer);
        return () => {
            isMounted.current = false;
        }
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (serviceAttribute.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (fn.validateForm(validateRef.current)) {
            confirmModalRef.current.show({
                icon: <i className='fal fa-calendar-check text-info mr-2'></i>,
                message: serviceAttribute.data && serviceAttribute.data.activeStartingDate ?
                    <>Do you want to apply changes to&nbsp;<span className='fw-500'>existing upcoming appointments</span>&nbsp;starting&nbsp;<span className='fw-500'>{moment(serviceAttribute.data.activeStartingDate).format('YYYY-MM-DD')}</span>?</> :
                    <>Do you want to apply changes to&nbsp;<span className='fw-500'>existing upcoming appointments</span>?</>,
                option1ClassName: 'btn btn-info shadow-0 bootbox-accept',
                option1Text: 'Apply to existing appointments',
                option2ClassName: 'btn btn-secondary shadow-0 bootbox-accept',
                option2Text: 'Only to new appointments',
                cancelText: 'Cancel',
                onOption1Click: async (event) => { await handleApplyToExisting(event) },
                onOption2Click: async (event) => { await handleDoNotApplyToExisting(event) },
                onCancel: async (event) => { await handleSave(event) }
            })
        }
    }

    const handleApplyToExisting = async (event) => {
        if (isMounted.current) {
            serviceAttribute.applyToExistingAppointments = true;
            await handleSave(event);
        }
    }

    const handleDoNotApplyToExisting = async (event) => {
        if (isMounted.current) {
            serviceAttribute.applyToExistingAppointments = false;
            await handleSave(event);
        }
    }

    const handleSave = async (event) => {
        if (isMounted.current) {
            confirmModalRef.current.close();

            const data = await serviceAttribute.save(true);
            if (isMounted.current) {
                if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                    props.onSuccess(event, data);
                }
            }
        }
    }

    const handleServiceOverrides = async () => {
        await serviceUserOverride.initialize(serviceAttribute.data.serviceId);
        serviceUserOverride.serviceName = serviceAttribute.data.name;
        serviceUserOverride.code = serviceAttribute.data.code;

        if (isMounted.current) {
            //await quickDrawer.deactivateQuickDrawer1();
            serviceUpdateTimer.current = setTimeout(() => {
                quickDrawer.activateQuickDrawer('serviceUserOverride', 'update', null, handleChangeServiceOverrideSuccess, handleChangeServiceOverrideCancel, handleChangeServiceOverrideError);
            }, 200);
        }
    }
    const handleDeletePendingChange = async (event) => {
        const data = await serviceAttribute.deletePending();
        if (isMounted.current) {
            if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                props.onSuccess(event, data);
            }
        }
    }
    const handleChangeServiceOverrideSuccess = (event) => {
        // if (props.onSuccess && fn.isFunction(props.onSuccess)) {
        //     props.onSuccess(event, null);
        // }
    }
    const handleChangeServiceOverrideCancel = () => {
    }
    const handleChangeServiceOverrideError = () => {
    }
    const handleServiceTimelineItems = () => {
        if (isMounted.current) {
            const extraProps = {
                serviceId: serviceAttribute.data.serviceId,
                code: serviceAttribute.data.code,
                name: serviceAttribute.data.name,
            }
            quickDrawer.activateQuickDrawer('serviceTimelineItems', 'update', extraProps, handleServiceTimelineItemsSuccess, handleServiceTimelineItemsCancel, handleServiceTimelineItemsError);
        }
    }
    const handleServiceTimelineItemsSuccess = (event) => {
        toast.dark(() => <p data-svc-tl-upd>Service timeline items updated.</p>);
    }
    const handleServiceTimelineItemsCancel = () => {
    }
    const handleServiceTimelineItemsError = () => {
    }

    const handleDeleteService = () => {
        quickDrawer.activateQuickDrawer('service', 'delete', null, handleDeleteServiceSuccess, handleDeleteServiceCancel);
    }
    const handleDeleteServiceSuccess = () => {
        quickDrawer.deactivateQuickDrawer1();
        toast.dark(() => <p data-svc-del>Service deleted.</p>);
    }
    const handleDeleteServiceCancel = () => { }

    const handleDefaultDurationChange = async (event) => {
        serviceAttribute.data.defaultDurationInMinutes = event.target.value;
        serviceAttribute.hasUnsavedChanges = true;
    }

    const handleDefaultRecallChange = async (event) => {
        serviceAttribute.data.defaultRecallPeriodInMonth = event.target.value;
        serviceAttribute.hasUnsavedChanges = true;
    }

    const handleDefaultPrescriptionExpiryChange = async (event) => {
        serviceAttribute.data.defaultPrescriptionExpireInMonths = event.target.value;
        serviceAttribute.hasUnsavedChanges = true;
    }

    const handleColorChange = (element) => {
        const value = element.value;

        serviceAttribute.data.colorHexValue = value;
        serviceAttribute.hasUnsavedChanges = true;
    }

    const handleNameChange = (event) => {
        serviceAttribute.data.name = event.target.value;
        serviceAttribute.hasUnsavedChanges = true;
    }

    const handleFeeChange = async (event) => {
        if (event.target.value) {
            const amount = parseFloat(fn.parseCurrency(event.target.value));
            serviceAttribute.data.fee = amount;
        } else {
            serviceAttribute.data.fee = null;
        }
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleChangeImmediate = (event) => {
        serviceAttribute.isChangeImmediate = (event.target.value === 'true');
        if (serviceAttribute.isChangeImmediate) {
            serviceAttribute.data.effectiveStarting = null;
        }
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleEffectiveDateChange = element => {
        const value = element.value;
        serviceAttribute.data.effectiveStarting = value ? moment(value).startOf('day') : null;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleCodeChange = (event) => {
        serviceAttribute.data.code = event.target.value;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleIsFullExamChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.isFullExam = checked;
        if (checked) {
            serviceAttribute.data.isBookable = true;
        }
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleIsBookableChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.isBookable = checked;
        if (!checked) {
            serviceAttribute.data.sendReminder = false;
            serviceAttribute.data.isRepeatable = false;
        }
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleIsRepeatableChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.isRepeatable = checked;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleIsTaxableChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.isTaxable = checked;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleSendReminderChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.sendReminder = checked;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleSendReviewChange = (event) => {
        const checked = !!event.target.checked;
        serviceAttribute.data.sendReview = checked;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleReminderOffsetChange = (event) => {
        serviceAttribute.data.reminderOffset = parseInt(event.target.value) || 0;
        serviceAttribute.hasUnsavedChanges = true;
    }
    const handleExamTemplateChange = (event) => {
        const templateId = event.target.value;
        serviceAttribute.data.examTemplateId = templateId;
        serviceAttribute.hasUnsavedChanges = true;
        if (!!templateId) {
            const template = examTemplates.find(e => e.id === templateId);
            serviceAttribute.data.examPublishedTemplateId = template.publishedTemplateId;
        }
        else {
            serviceAttribute.data.examPublishedTemplateId = null;
        }
    }
    const handleActiveStartingDateChange = element => {
        const value = element.value;

        serviceAttribute.data.activeStartingDate = value ? moment(value).startOf('day') : moment().startOf('day');
        serviceAttribute.hasUnsavedChanges = true;
    }

    return <>
        <Observer>{() =>
            <>
                {
                    (props.drawer === quickDrawer.drawerOpened) ?
                        <GlobalHotKeys
                            keyMap={{
                                close: ['esc'],
                            }}
                            handlers={{
                                close: event => {
                                    handleCancel(event)
                                },
                            }}
                            allowChanges={true}
                        /> : null
                }
            </>
        }</Observer>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <fieldset disabled={serviceAttribute.isSaving}>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('service', 'update')}
                        action='Update'
                        category='Service'
                        className='services'
                        onCancel={handleCancel}
                    />
                    <Observer>{() => <>
                        <div className='quick-drawer-body'>
                            {serviceAttribute.isReady && ready ?
                                <FadeIn>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <strong>{serviceAttribute.data.id ? `There are pending changes that will be applied on ${moment(serviceAttribute.data.effectiveStarting).format('YYYY-MM-DD')}` : ''}</strong>
                                        </div>
                                    </div>
                                    <div className='update-service body-content'>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='form-group'>
                                                            <label><small>Color</small></label>
                                                            <PresetColorBox
                                                                id='color'
                                                                applyValueMode={'instantly'}
                                                                disabled={serviceAttribute.data.isSubsidized}
                                                                value={serviceAttribute.data.colorHexValue}
                                                                onValueChanged={handleColorChange}
                                                                presetColors={(props.extraProps && props.extraProps.presetColors) ? props.extraProps.presetColors : []}
                                                                label='Previously selected colors'
                                                            >
                                                            </PresetColorBox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0 validate validate-required'>
                                                        <label className='required'><small>Name</small></label>
                                                        <input
                                                            id='service-name'
                                                            type='text'
                                                            className='form-control'
                                                            maxLength='150'
                                                            autoComplete='off'
                                                            disabled={serviceAttribute.data.isSubsidized}
                                                            value={serviceAttribute.data.name}
                                                            onChange={handleNameChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0 validate validate-required'>
                                                        <label className='required'><small>Code</small></label>
                                                        <input
                                                            id='service-code'
                                                            type='text'
                                                            className='form-control'
                                                            maxLength="25"
                                                            autoComplete='off'
                                                            disabled={serviceAttribute.data.isSubsidized}
                                                            value={serviceAttribute.data.code}
                                                            onChange={handleCodeChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='custom-control custom-switch'>
                                                            <input
                                                                id='is-full-exam'
                                                                type="checkbox"
                                                                name='is-full-exam'
                                                                className='custom-control-input'
                                                                disabled={serviceAttribute.data.isSubsidized}
                                                                checked={!!serviceAttribute.data.isFullExam}
                                                                onChange={handleIsFullExamChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='is-full-exam'>{serviceAttribute.data.isFullExam ? 'This is a full exam' : 'This is a not full exam'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='custom-control custom-switch'>
                                                            <input
                                                                id='is-bookable'
                                                                type="checkbox"
                                                                name='is-bookable'
                                                                className='custom-control-input'
                                                                disabled={serviceAttribute.data.isSubsidized}
                                                                checked={!!serviceAttribute.data.isBookable}
                                                                onChange={handleIsBookableChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='is-bookable'>{serviceAttribute.data.isBookable ? 'This can be booked as an appointment' : 'This cannot be booked as an appointment'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='custom-control custom-switch'>
                                                            <input
                                                                id='is-repeatable'
                                                                type="checkbox"
                                                                name='is-repeatable'
                                                                className='custom-control-input'
                                                                checked={!!serviceAttribute.data.isRepeatable}
                                                                disabled={!serviceAttribute.data.isBookable}
                                                                onChange={handleIsRepeatableChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='is-repeatable'>{serviceAttribute.data.isRepeatable ? 'This can be booked as repeatable appointments' : 'This can be booked as single appointment only'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='form-custom-control custom-switch'>
                                                            <input
                                                                id='is-taxable'
                                                                type="checkbox"
                                                                name='is-taxable'
                                                                className='custom-control-input'
                                                                disabled={serviceAttribute.data.isSubsidized}
                                                                checked={!!serviceAttribute.data.isTaxable}
                                                                onChange={handleIsTaxableChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='is-taxable'>{serviceAttribute.data.isTaxable ? 'Apply tax to the service' : 'No tax will be applied'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        {
                                            serviceAttribute.data.isBookable &&
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-0'>
                                                            <label><small>Default Duration</small></label>
                                                            <div className='input-group'>
                                                                <input
                                                                    id='service-default-duration'
                                                                    type='number'
                                                                    className='form-control'
                                                                    min={0}
                                                                    max={480}
                                                                    step={5}
                                                                    autoComplete='off'
                                                                    value={serviceAttribute.data.defaultDurationInMinutes}
                                                                    onChange={handleDefaultDurationChange}
                                                                />
                                                                <div className='input-group-append'>
                                                                    <span className='input-group-text'>min.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        }
                                        {
                                            serviceAttribute.data.isBookable && serviceAttribute.data.isFullExam &&
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-0'>
                                                            <label><small>Default Recall</small></label>
                                                            <div className='input-group'>
                                                                <input
                                                                    id='service-default-recall'
                                                                    type='number'
                                                                    className='form-control'
                                                                    min={0}
                                                                    step={1}
                                                                    autoComplete='off'
                                                                    disabled={serviceAttribute.data.isSubsidized}
                                                                    value={serviceAttribute.data.defaultRecallPeriodInMonth}
                                                                    onChange={handleDefaultRecallChange}
                                                                />
                                                                <div className='input-group-append'>
                                                                    <span className='input-group-text'>mo.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        }
                                        {
                                            serviceAttribute.data.isBookable && serviceAttribute.data.isFullExam &&
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-0'>
                                                            <label><small>Default Prescription Expiry</small></label>
                                                            <div className='input-group'>
                                                                <input
                                                                    id='service-default-expiry-months'
                                                                    type='number'
                                                                    className='form-control'
                                                                    min={0}
                                                                    step={1}
                                                                    autoComplete='off'
                                                                    value={serviceAttribute.data.defaultPrescriptionExpireInMonths}
                                                                    onChange={handleDefaultPrescriptionExpiryChange}
                                                                />
                                                                <div className='input-group-append'>
                                                                    <span className='input-group-text'>mo.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        }
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <label><small>Fee</small></label>
                                                        <MaskedInput
                                                            id='service-fee'
                                                            type='text'
                                                            className='form-control'
                                                            spellCheck={false}
                                                            mask={MaskKeys.CURRENCY_MASK}
                                                            autoComplete='off'
                                                            disabled={serviceAttribute.data.isSubsidized}
                                                            value={serviceAttribute.data.fee ? serviceAttribute.data.fee : ''}
                                                            onChange={handleFeeChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-tenant mb-0'>
                                                        <label><small>Exam Template</small></label>
                                                        <select
                                                            id='update-exam-template-select'
                                                            className='custom-select form-control'
                                                            value={serviceAttribute.data.examTemplateId || ''}
                                                            onChange={handleExamTemplateChange}
                                                        >
                                                            <option value=''>Not selected</option>
                                                            {examTemplates.map(d => <option value={d.id}>{d.name}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='form-custom-control custom-switch'>
                                                            <input
                                                                id='send-reminder'
                                                                type="checkbox"
                                                                name='send-reminder'
                                                                className='custom-control-input'
                                                                checked={!!serviceAttribute.data.sendReminder}
                                                                onChange={handleSendReminderChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='send-reminder'>Send Reminder</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        {
                                            serviceAttribute.data.sendReminder &&
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-0 validate validate-required'>
                                                            <label><small>Reminder offset</small></label>
                                                            <div className='input-group'>
                                                                <input
                                                                    id='reminder-offset'
                                                                    type='number'
                                                                    className='form-control'
                                                                    min={0}
                                                                    step={5}
                                                                    value={serviceAttribute.data.reminderOffset}
                                                                    onChange={handleReminderOffsetChange}
                                                                />
                                                                <div className='input-group-append'>
                                                                    <span className='input-group-text'>min.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        }
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className='form-custom-control custom-switch'>
                                                            <input
                                                                id='send-review'
                                                                type="checkbox"
                                                                name='send-review'
                                                                className='custom-control-input'
                                                                checked={!!serviceAttribute.data.sendReview}
                                                                onChange={handleSendReviewChange}
                                                            />
                                                            <label className='custom-control-label' htmlFor='send-review'>{serviceAttribute.data.sendReview ? 'Enabled for review request' : 'Disabled for review request'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        {
                                            // If the service is not active yet, show the active starting date; and all the changes should be immediate (default)
                                            serviceAttribute.isActiveStartingDateInFuture ?
                                                <section>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className='form-group mb-0'>
                                                                <div className='form-group'>
                                                                    <label><small>Active starting date</small></label>
                                                                    <DateBox
                                                                        id='active-starting-date'
                                                                        type='date'
                                                                        displayFormat={'yyyy-MM-dd'}
                                                                        useMaskBehavior={false}
                                                                        showClearButton={false}
                                                                        min={moment().toDate()}
                                                                        disabled={serviceAttribute.data.isSubsidized}
                                                                        value={serviceAttribute.data.activeStartingDate ? moment(serviceAttribute.data.activeStartingDate).toDate() : null}
                                                                        onValueChanged={handleActiveStartingDateChange}
                                                                        onOpened={() => { document.querySelector('.dx-datebox-wrapper').style.zIndex = fn.getHighestZIndex() + 1; }}
                                                                    >
                                                                    </DateBox>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                :
                                                // if active starting date is same as today or is in the past, then changes could be applied directly to service or in service attribute
                                                <>
                                                    <section>
                                                        <div className='row'>
                                                            <div className='col-12'>
                                                                <div className={'form-group validate validate-required mb-0'}>
                                                                    <label className='required'><small>When to apply the change?</small></label>
                                                                    <div className='custom-control custom-radio mb-2'>
                                                                        <input
                                                                            id='changeImmediate'
                                                                            type='radio'
                                                                            name='isChangeImmediate'
                                                                            value='true'
                                                                            disabled={serviceAttribute.data.isSubsidized}
                                                                            checked={serviceAttribute.isChangeImmediate}
                                                                            className='custom-control-input'
                                                                            onChange={handleChangeImmediate}
                                                                        />
                                                                        <label
                                                                            htmlFor='changeImmediate'
                                                                            className='custom-control-label'
                                                                        >Immediately
                                                                        </label>
                                                                    </div>
                                                                    <div className='custom-control custom-radio mb-2'>
                                                                        <input
                                                                            id='changeScheduled'
                                                                            type='radio'
                                                                            name='isChangeImmediate'
                                                                            value='false'
                                                                            disabled={serviceAttribute.data.isSubsidized}
                                                                            checked={!serviceAttribute.isChangeImmediate}
                                                                            className='custom-control-input'
                                                                            onChange={handleChangeImmediate}
                                                                        />
                                                                        <label
                                                                            htmlFor='changeScheduled'
                                                                            className='custom-control-label'
                                                                        >Scheduled on this date
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-10'>
                                                                <div className={'form-group validate validate-date ' + (!serviceAttribute.isChangeImmediate ? 'validate-required' : '')}>
                                                                    <label className='required' htmlFor='effective-date'><small>Effective Date<span className='text-gray-500'>(yyyy-mm-dd)</span></small></label>
                                                                    <DateBox
                                                                        id='effective-date'
                                                                        type='date'
                                                                        displayFormat={'yyyy-MM-dd'}
                                                                        useMaskBehavior={false}
                                                                        showClearButton={false}
                                                                        disabled={serviceAttribute.data.isSubsidized || serviceAttribute.isChangeImmediate}
                                                                        min={moment().toDate()}
                                                                        value={serviceAttribute.data.effectiveStarting ? moment(serviceAttribute.data.effectiveStarting).toDate() : null}
                                                                        onValueChanged={handleEffectiveDateChange}
                                                                        onOpened={() => { document.querySelector('.dx-datebox-wrapper').style.zIndex = fn.getHighestZIndex() + 1; }}
                                                                    >
                                                                    </DateBox>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section>
                                                        <div className='row'>
                                                            <div className='col-6'>
                                                                <div className={'form-group'}>
                                                                    {
                                                                        serviceAttribute.data.id ?
                                                                            <button
                                                                                type='button'
                                                                                className='btn btn-warning mr-2'
                                                                                title='Remove pending changes'
                                                                                disabled={serviceAttribute.data.isSubsidized}
                                                                                onClick={handleDeletePendingChange}
                                                                            >Remove Pending Changes</button> : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </>
                                        }
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()}
                        </div>
                        <div className='quick-drawer-action'>
                            <div className='row'>
                                <div className='col-4'>
                                    {
                                        serviceAttribute.data.isBookable &&
                                        <button
                                            type='button'
                                            className='btn btn-icon'
                                            title='Manage User Overrides'
                                            onClick={handleServiceOverrides}
                                        >
                                            <i className='fal fa-users-cog'></i>
                                        </button>
                                    }
                                    {
                                        serviceAttribute.data.isBookable &&
                                        <button
                                            type='button'
                                            className='btn btn-icon'
                                            title='Manage Timeline Items'
                                            onClick={handleServiceTimelineItems}
                                        >
                                            <i className='fal fa-clock'></i>
                                        </button>
                                    }
                                </div>
                                <div className='col-8'>
                                    <div className='float-right'>
                                        {
                                            !serviceAttribute.data.isSubsidized && <button
                                                type='button'
                                                className='btn btn-sm btn-danger mr-1'
                                                onClick={handleDeleteService}
                                            >Delete</button>
                                        }
                                        <button
                                            type='submit'
                                            className='btn btn-sm btn-success'
                                        >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    }</Observer>
                </div>
            </fieldset>
        </form>
        <BodyEnd>
            <ConfirmModal ref={confirmModalRef} />
        </BodyEnd>
    </>
}

export default UpdateServiceAttribute;
